// ~/composables/useCheckout.ts

import { useCartStore } from '~/store/cartStore';
import { useUserStore } from '~/store/userStore';
import { useUIStore } from '~/store/uiStore';
import { watch, computed } from 'vue';
import { ModalTypes } from '@/types/enums';

export default function useCheckout() {
  const userStore = useUserStore();
  const uiStore = useUIStore();
  const cartStore = useCartStore();

  const isLoggedIn = computed(() => userStore.userData?.is_logged_in || false);

  // Watch for changes in userData
  watch(
    () => userStore.userData,
    (newUserData) => {
      if (cartStore.checkoutWithoutLoginInitiated && newUserData?.is_logged_in) {
        //console.log('Checkout initiated after login');
        //cartStore.checkOut();
      }
    },
    { deep: true }
  );

  const checkOut = () => {
    console.log('Checkout initiated..., userdata:', userStore.userData, 'isLoggedin: ', isLoggedIn.value);
    if (isLoggedIn.value) {
      cartStore.checkOut();
    } else {
      cartStore.setCheckoutWithLoginInitiated(); // using cartStore's initiateCheckout
      uiStore.setModalType(ModalTypes.LOGIN, "Please login or sign up to continue checkout. It only takes a minute and is completely free.");
    }
  };

  const reset = () => {

  };

  return {
    checkOut,
    reset
  };
}
